module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.complete),
      expression: "!complete"
    }]
  }, [_c('div', [_c('commonFormRender', {
    ref: "form",
    attrs: {
      "form": _vm.form,
      "formField": _vm.nodeField,
      "modelId": _vm.modelId,
      "isReadonly": _vm.isReadonly,
      "complete": _vm.complete
    },
    on: {
      "uploading": _vm.uploading
    }
  }, [_c('div', {
    staticClass: "m-t-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    staticClass: "flowForm",
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])]), _vm._v(" "), (_vm.currentData.currentType !== _vm.UESR_CONSTANT) ? _c('flow-process-dialog', {
    ref: "flowProcessControl",
    attrs: {
      "currentData": _vm.currentData
    },
    on: {
      "handleDialogResult": _vm.handleDialogResult
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a31803c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/form.vue
// module id = 1968
// module chunks = 2